import { useMemo } from 'react'

import {
  useGetMeetingsSupergraphQuery,
  useLazyGetMeetingsSupergraphQuery,
  useLazyGetMeetingSupergraphQuery,
} from 'shared/api/meetings'

import { buildSupergraphInput } from './supergraph_meeting_search_utils'
import { VISIBLE_RANGE_PAGE_SIZE } from './visible_range_constants'

export const useSupergraphSearchDataQueries = ({
  skipQueries,
  isSupergraphEnabled,
  shouldLoadToday,
  filters,
  visibleRangeQueryVariables,
  queryOptions,
  backgroundPollingConfig,
  visibleRangePollingInterval,
}) => {
  const futureSupergraphInput = useMemo(
    () => (filters
      ? buildSupergraphInput(filters, {
        first: 30,
        after: null,
        order: 'ASC',
      })
      : null),
    [filters],
  )

  const todaySupergraphInput = useMemo(
    () => (filters
      ? buildSupergraphInput(filters, {
        today: true,
        first: 10_000,
        after: null,
        order: 'ASC',
      })
      : null),
    [filters],
  )

  const pastSupergraphInput = useMemo(
    () => (filters
      ? buildSupergraphInput(filters, {
        past: true,
        first: 30,
        after: null,
        order: 'DESC',
      })
      : null),
    [filters],
  )

  const visibleRangeSupergraphInput = useMemo(
    () => (visibleRangeQueryVariables
      ? buildSupergraphInput(visibleRangeQueryVariables, {
        first: VISIBLE_RANGE_PAGE_SIZE,
        after: null,
        order: 'ASC',
      })
      : null),
    [visibleRangeQueryVariables],
  )

  const futureSupergraph = useGetMeetingsSupergraphQuery(futureSupergraphInput || {}, {
    skip: skipQueries || !isSupergraphEnabled,
    ...queryOptions,
  })

  const todaySupergraph = useGetMeetingsSupergraphQuery(todaySupergraphInput || {}, {
    skip: skipQueries || !shouldLoadToday || !isSupergraphEnabled,
    ...queryOptions,
  })

  const pastSupergraph = useGetMeetingsSupergraphQuery(pastSupergraphInput || {}, {
    skip: skipQueries || !isSupergraphEnabled,
    ...queryOptions,
  })

  const { data: visibleRangeDataSuper } = useGetMeetingsSupergraphQuery(
    visibleRangeSupergraphInput || {},
    {
      ...backgroundPollingConfig,
      pollingInterval: visibleRangePollingInterval,
      skip: skipQueries || !visibleRangeQueryVariables || !isSupergraphEnabled,
      refetchOnMountOrArgChange: false,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    },
  )

  const [triggerSupergraph, resultSupergraph] = useLazyGetMeetingsSupergraphQuery()
  const [triggerVisibleRangeNextSupergraph, visibleRangeNextResultSupergraph] = useLazyGetMeetingsSupergraphQuery()
  const [triggerMeetingSupergraph] = useLazyGetMeetingSupergraphQuery()

  return {
    futureSupergraph,
    todaySupergraph,
    pastSupergraph,
    visibleRangeDataSuper,
    triggerSupergraph,
    resultSupergraph,
    triggerVisibleRangeNextSupergraph,
    visibleRangeNextResultSupergraph,
    triggerMeetingSupergraph,
  }
}
